import React from 'react'
import { Main } from './components'

const Affiliates = () => <Main />

export default Affiliates
